export default __webpack_public_path__ + "static/1-ab846a54e1d2b3cb77025efb4501439c.jpeg";